module.exports = __webpack_public_path__ + "images/search-9230fee3614781dbb0de6df6f773e4b1.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/search.png
// module id = 44
// module chunks = 0